import React from "react";
import "@abb/abb-common-ux-react/styles.css";
import "./shared.sass";
import {
  Input,
  Tooltip,
  WithTooltip,
  Dropdown,
  DropdownOption,
  Button,
} from "@abb/abb-common-ux-react";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { ITrendViewData } from "../../models/trends/TrendViewData";
import moment from "moment";
import { DatePicker, Space } from "antd";
import "antd/dist/antd.css";
import DateFormatting from "../../utilities/DateFormat";
import { ISourceViewData } from "../../models/source/SourceViewData";
interface ISidebarListProperties {
  selectedDateRange?: any[];
  dateRangeChangeHandler?: (val: any) => any;
  setTrendCustomFromDate?: (val: any) => any;
  setTrendCustomToDate?: (val: any) => any;
  selectFromDate?: any[];
  selectToDate?: any[];
  daterange?: any[];
  selectedGrade?: any[];
  GradeChangeHandler?: (val: any) => any;
  trendDropdownGradeList?: ITrendViewData[];
  selectedProduct?: any[];
  ProductChangeHandler?: (val: any) => any;
  trendDropdownProductList?: ITrendViewData[];
  selectedSample?: any[];
  SampleChangeHandler?: (val: any) => any;
  trendDropdownSampleList?: ITrendViewData[];
  listData?: any[];
  // //Source
  trendDropdownSourceList?: any;
  selectedSource?: any[];
  SourceChangeHandler?: (val: any) => any;
  loadingProperties?: boolean;
}
class SidebarTrend extends React.Component<ISidebarListProperties, {}> {
  constructor(props: ISidebarListProperties) {
    super(props);
    this.state = {};
  }

  public componentDidMount() {}

  public render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="row p-0 m-0">
              <div className="col-sm col-md">
                <Dropdown
                  label={t(CONSTANTS.SAMPLE_DATE)}
                  allowAdd={false}
                  clearable={false}
                  placeholder={t(CONSTANTS.SELECT_DATE_RANGE)}
                  value={this.props.selectedDateRange}
                  onChange={this.props.dateRangeChangeHandler}
                  disabled={this.props.loadingProperties}
                >
                  {this.props.daterange.map((o: any) => (
                    <DropdownOption
                      key={o.value}
                      label={o.label}
                      value={o.value}
                    />
                  ))}
                </Dropdown>
              </div>
            </div>
            {this.props.selectedDateRange[0]?.value === 4 && (
              <div>
                <div className="row trend p-0 m-0">
                  <div className="col-sm col-md">
                    <div className="custom-label">{t(CONSTANTS.FROM)}</div>
                    <Space direction="vertical" size={12}>
                      <DatePicker
                        format={
                          DateFormatting.getDateTimeRegion() ||
                          "DD-MM-YYYY hh:mm A"
                        }
                        showTime={{ use12Hours: true, format: "hh:mm A" }}
                        defaultValue={
                          this.props.selectFromDate
                            ? moment(this.props.selectFromDate)
                            : null
                        }
                        onChange={this.props.setTrendCustomFromDate}
                        onOk={this.props.setTrendCustomFromDate}
                        allowClear={true}
                        bordered={true}
                        placeholder={
                          DateFormatting.getDateTimeRegion() ||
                          "DD-MM-YYYY hh:mm A"
                        }
                        disabled={this.props.loadingProperties}
                      />
                    </Space>
                  </div>
                </div>
                <div className="row trend p-0 m-0">
                  <div className="col-sm col-md">
                    <div className="custom-label">{t(CONSTANTS.TO)}</div>
                    <Space direction="vertical" size={12}>
                      <DatePicker
                        format={
                          DateFormatting.getDateTimeRegion() ||
                          "DD-MM-YYYY hh:mm A"
                        }
                        showTime={{ use12Hours: true, format: "hh:mm A" }}
                        defaultValue={
                          this.props.selectToDate
                            ? moment(this.props.selectToDate)
                            : null
                        }
                        onChange={this.props.setTrendCustomToDate}
                        onOk={this.props.setTrendCustomToDate}
                        allowClear={true}
                        bordered={true}
                        placeholder={
                          DateFormatting.getDateTimeRegion() ||
                          "DD-MM-YYYY hh:mm A"
                        }
                        disabled={this.props.loadingProperties}
                      />
                    </Space>
                  </div>
                </div>
              </div>
            )}

            <div className="row p-0 m-0">
              <div className="col-sm col-md">
                <Dropdown
                  label={t(CONSTANTS.MODULE_SOURCE)}
                  allowAdd={false}
                  clearable={false}
                  multiselect={true}
                  placeholder={t(CONSTANTS.SELECT_SOURCE)}
                  value={this.props.selectedSource}
                  onChange={this.props.SourceChangeHandler}
                >
                  <DropdownOption key="tSrcall" label="ALL" value="ALL" />
                  {this.props?.trendDropdownSourceList?.map((o: any) => (
                    <DropdownOption key={o.id} label={o.name} value={o.id} />
                  ))}
                </Dropdown>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-sm col-md">
                <Dropdown
                  label={t(CONSTANTS.MODULE_GRADE)}
                  allowAdd={false}
                  clearable={false}
                  multiselect={true}
                  placeholder={t(CONSTANTS.SELECT_GRADE)}
                  value={this.props.selectedGrade}
                  onChange={this.props.GradeChangeHandler}
                >
                  <DropdownOption key="tGrdall" label="ALL" value="ALL" />
                  {this.props?.trendDropdownGradeList?.map((o: any) => (
                    <DropdownOption key={o.id} label={o.name} value={o.id} />
                  ))}
                </Dropdown>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-sm col-md">
                <Dropdown
                  label={t(CONSTANTS.MODULE_PRODUCT)}
                  allowAdd={false}
                  clearable={false}
                  multiselect={true}
                  placeholder={t(CONSTANTS.SELECT_PRODUCT)}
                  value={this.props.selectedProduct}
                  onChange={this.props.ProductChangeHandler}
                >
                  <DropdownOption key="tPrdall" label="ALL" value="ALL" />
                  {this.props?.trendDropdownProductList?.map((o: any) => (
                    <DropdownOption key={o.id} label={o.name} value={o.id} />
                  ))}
                </Dropdown>
              </div>
            </div>
            <div className="row p-0 m-0">
              <div className="col-sm col-md">
                <Dropdown
                  label={t(CONSTANTS.MODULE_SAMPLE)}
                  allowAdd={false}
                  clearable={false}
                  multiselect={true}
                  searchable={true}
                  placeholder={t(CONSTANTS.SELECT_SAMPLE)}
                  value={this.props.selectedSample}
                  onChange={this.props.SampleChangeHandler}
                >
                  <DropdownOption key="tSamplecall" label="ALL" value="ALL" />
                  {this.props.trendDropdownSampleList.map((o: any) => (
                    <DropdownOption key={o.id} label={o.name} value={o.id} />
                  ))}
                </Dropdown>
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}

export default SidebarTrend;
